import Search from '../header/Search';
import { useViewport } from 'developer-docs-shared-components/hooks/useViewport';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSearch = styled(Search).withConfig({
  displayName: "SearchPageInput__StyledSearch",
  componentId: "sc-1azi0om-0"
})(["margin-right:0px;padding-bottom:16px;"]);

/**
 * Created to conditionally insert the search input above the results
 * on the search page to correct a styling issue. Couldn't be done on \
 * the container, since the viewport context didn't exist.
 */
const SearchPageInput = () => {
  const {
    isMobile,
    isBelowLaptop
  } = useViewport();
  return isBelowLaptop && !isMobile ? /*#__PURE__*/_jsx(StyledSearch, {}) : null;
};
export default SearchPageInput;